<div *ngIf="pageWiseStyle === ''" [ngClass]="data['changeStyle'] ? 'error-change-style' : 'error-dialog'">
    <div [ngClass]="data['changeStyle'] ? 'mark-change-style' : 'mark'">
        <p style="margin: 0;">!</p>
    </div>
    <p [ngClass]="data['changeStyle'] ? 'content-change-style' : 'content'">{{data['message']}}</p>
    <button *ngIf="!data['delete']; else confirmation" (click)="close()" type="button" [ngClass]="data['changeStyle'] ? 'closeButton-change-style' : 'ok-button'">OK</button>
    <ng-template #confirmation>
        <div class="row newcsserror" style="left: -4vw;">
            <button (click)="confirmDelete()" type="button" [ngClass]="data['changeStyle'] ? 'closeButton-change-style' : 'closeButton'">Yes</button>
            <button (click)="close()" type="button" [ngClass]="data['changeStyle'] ? 'closeButton-change-style' : 'closeButton'">No</button>
        </div>
    </ng-template>
</div>
<div *ngIf="pageWiseStyle !== ''" [ngClass]="pageWiseStyle !== '' ? pageWiseStyle : ''"  class="error-change-style">
    <div class="mark-change-style">
        <p class="xx-large-text">!</p>
    </div>
    <p>{{data['message']}}</p>
    <button *ngIf="!data['delete']; else confirmation" (click)="close()" type="button" class="closeButton-change-style">OK</button>
    <ng-template #confirmation>
        <div class="row newcsserror" style="left: -4vw;">
            <button (click)="confirmDelete()" type="button" class="closeButton-change-style">Yes</button>
            <button (click)="close()" type="button" class="closeButton-change-style">No</button>
        </div>
    </ng-template>
</div>